const gql = require("graphql-tag");

const DELETE = gql`
  mutation ($data: ConfirmRemoveInput!) {
    ConfirmRemove(data: $data) {
      n
      deletedCount
      ok
    }
  }
`;

const UPDATE = gql`
  mutation ($data: ConfirmUpdateInput!) {
    ConfirmUpdate(data: $data) {
      n
      nModified
      ok
    }
  }
`;

const CREATE = gql`
  mutation ($data: ConfirmInput!) {
    ConfirmCreate(data: $data) {
      id
      company {
        id
        name
      }
      code
      dimensions
      product
      productNumber
      productDate
      productPalace
      serino
      controlNo
      description
      isActive
    }
  }
`;

const MANUEL_CREATE = gql`
  mutation ($data: [ConfirmInput]!) {
    ManuelConfirmCreate(data: $data) {
      id
      company {
        id
        name
      }
      code
      dimensions
      product
      productNumber
      productDate
      productPalace
      serino
      controlNo
      description
      isActive
    }
  }
`;

export const confirmMutations = {
  DELETE,
  UPDATE,
  CREATE,
  MANUEL_CREATE,
};
